export default "data:text/javascript;base64,aW1wb3J0IFRUYWJzIGZyb20gIi4vVFRhYnMudnVlIjsKCmV4cG9ydCBkZWZhdWx0IFRUYWJzOwo="